import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

import { MultilineTypography } from '../../theme/components/MultilineTypography'

const CHARACTERS_PER_ROW = 200

interface Props {
  isEdit?: boolean
  value?: string
  onChange?: any
  error?: boolean
  inputProps?: any
}

export const CustomEditInputComponent = ({
  isEdit = false,
  value,
  onChange,
  error,
  inputProps = { maxLength: 100 },
}: Props) => {
  return isEdit ? (
    <FormControl sx={{ width: '100%' }}>
      <TextField
        data-testid="inputField"
        value={value}
        slotProps={{ htmlInput: { maxLength: inputProps.maxLength } }}
        onChange={(e) => onChange(e.target.value)}
        error={error}
        multiline={inputProps.maxLength > CHARACTERS_PER_ROW}
        rows={inputProps.maxLength > CHARACTERS_PER_ROW ? 5 : 1} //eslint-disable-line
      />
    </FormControl>
  ) : (
    <MultilineTypography variant="body2" text={value} />
  )
}
